// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-menu__card[data-v-31157a06] .v-card-content{padding:0}[data-v-31157a06] .v-btn.v-menu-activator{color:#7f839c}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
